import React from "react";
import { useNavigate } from "react-router-dom";
import { FaInstagram, FaTiktok, FaYoutube, FaTwitter, FaFacebookF, FaApple, FaGooglePlay } from 'react-icons/fa';
import "./Footer.css";

const Footer: React.FC = () => {
  const navigate = useNavigate();

  return (
    <footer className="landing-page-footer">
      <div className="landing-footer-content">
        <div className="landing-footer-sections">
          <div className="landing-footer-section">
            <h3>Legal</h3>
            <ul>
              <li><a href="/all-policies" onClick={(e) => { e.preventDefault(); navigate('/all-policies'); }}>All Policies</a></li>
              <li><a href="/privacy" onClick={(e) => { e.preventDefault(); navigate('/privacy'); }}>Privacy</a></li>
              <li><a href="/terms" onClick={(e) => { e.preventDefault(); navigate('/terms'); }}>Terms</a></li>
              <li><a href="/consent" onClick={(e) => { e.preventDefault(); navigate('/consent'); }}>Consumer Health Data Privacy Policy</a></li>
              <li><a href="/cookies" onClick={(e) => { e.preventDefault(); navigate('/cookies'); }}>Cookie Policy</a></li>
              <li><a href="#" onClick={(e) => e.preventDefault()}>Intellectual Property</a></li>
              <li><a href="#" onClick={(e) => e.preventDefault()}>Accessibility Statement</a></li>
            </ul>
          </div>

          <div className="landing-footer-section">
            <h3>Careers</h3>
            <ul>
              <li><a href="#" onClick={(e) => e.preventDefault()}>Careers Portal</a></li>
              <li><a href="/blog" onClick={(e) => { e.preventDefault(); navigate('/blog'); }}>Tech Blog</a></li>
            </ul>
          </div>

          <div className="landing-footer-section">
            <h3>Social</h3>
            <div className="social-icons">
              <a href="#" onClick={(e) => e.preventDefault()} aria-label="Instagram"><FaInstagram /></a>
              <a href="#" onClick={(e) => e.preventDefault()} aria-label="TikTok"><FaTiktok /></a>
              <a href="#" onClick={(e) => e.preventDefault()} aria-label="YouTube"><FaYoutube /></a>
              <a href="#" onClick={(e) => e.preventDefault()} aria-label="Twitter"><FaTwitter /></a>
              <a href="#" onClick={(e) => e.preventDefault()} aria-label="Facebook"><FaFacebookF /></a>
            </div>
          </div>

          <div className="landing-footer-section">
            <h3>FAQ</h3>
            <ul>
              <li><a href="#" onClick={(e) => e.preventDefault()}>Destinations</a></li>
              <li><a href="#" onClick={(e) => e.preventDefault()}>Press Room</a></li>
              <li><a href="/contact" onClick={(e) => { e.preventDefault(); navigate('/contact'); }}>Contact</a></li>
              <li><a href="#" onClick={(e) => e.preventDefault()}>Promo Code</a></li>
            </ul>
          </div>
        </div>

        <div className="landing-footer-app-download">
          <h2>Get the app!</h2>
          <div className="download-buttons">
            <a href="#" className="download-btn apple-btn" onClick={(e) => e.preventDefault()}>
              <FaApple className="download-icon" />
              <div className="download-text">
                <span className="download-label">Download on the</span>
                <span className="download-store">App Store</span>
              </div>
            </a>
            <a href="#" className="download-btn google-btn" onClick={(e) => e.preventDefault()}>
              <FaGooglePlay className="download-icon" />
              <div className="download-text">
                <span className="download-label">GET IT ON</span>
                <span className="download-store">Google Play</span>
              </div>
            </a>
          </div>
        </div>

        <div className="landing-footer-description">
          <p>
            Welcome to Fervoir — where meaningful connections begin.
            Whether you’re searching for love, companionship, or a refreshing new connection, Fervoir gives you access to a global community of singles ready to meet someone like you. In a world where most relationships start online, Fervoir keeps things simple, safe, and authentic.
          </p>
          <p>
            Every identity and orientation is embraced here — love has no labels on Fervoir.
            Find a long-term partner, discover new friends, or immerse yourself in new campus experiences with Fervoir.
            This is not just a dating app. It’s a space built for real people and real possibilities.
          </p>
        </div>

        <div className="landing-footer-bottom">
          <div className="landing-footer-links-wrapper">
            <a href="/faq" onClick={(e) => { e.preventDefault(); navigate('/faq'); }}>FAQ</a>
            <span className="landing-separator">/</span>
            <a href="/safety-tips" onClick={(e) => { e.preventDefault(); navigate('/safety-tips'); }}>Safety Tips</a>
            <span className="landing-separator">/</span>
            <a href="/terms" onClick={(e) => { e.preventDefault(); navigate('/terms'); }}>Terms</a>
            <span className="landing-separator">/</span>
            <a href="/cookies" onClick={(e) => { e.preventDefault(); navigate('/cookies'); }}>Cookie Policy</a>
            <span className="landing-separator">/</span>
            <a href="/privacy-settings" onClick={(e) => { e.preventDefault(); navigate('/privacy-settings'); }}>Privacy Settings</a>
          </div>
          <p className="landing-footer-copyright">© 2025 Fervoir LLC, All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;